import { initBrowserLogger } from './loggerHelpers';
import { wrapPageElement } from './gatsby-common';

export const onClientEntry = () => {
  initBrowserLogger();
};

export { wrapPageElement };
